import React, { Component } from "react"
import TableFiscaisTrash from "./TableFiscaisTrash"
import * as ApiHelper from "../../ApiHelper"
import { Loading, HttpError } from "../../components"
import Layout from "../Layout"
export default class FiscaisTrash extends Component {
  constructor() {
    super()
    this.getFiscais = this.getFiscais.bind(this)
    this.didRestore = this.didRestore.bind(this)
    this.filter = this.filter.bind(this)
    this.state = { fiscais: [], initialFiscais: [], showTable: false }
  }
  componentWillMount() {
    this.getFiscais()
  }
  getFiscais() {
    ApiHelper.getFiscaisTrash(fiscais => {
      if (fiscais) {
        this.setState({
          fiscais: fiscais,
          initialFiscais: fiscais,
          showTable: true
        })
      }
    })
  }
  didRestore() {
    this.getFiscais()
  }
  filter(event) {
    var searchText = event.target.value.toLowerCase()
    var filtered = this.state.initialFiscais.filter(fiscal => {
      return (
        fiscal.nome.toLowerCase().search(searchText) !== -1 ||
        fiscal.cpf.toLowerCase().search(searchText) !== -1 ||
        fiscal.email.toLowerCase().search(searchText) !== -1 ||
        fiscal.unidade_orcamentaria.uni_orc.toLowerCase().search(searchText) !==
          -1
      )
    })
    this.setState({
      fiscais: filtered
    })
  }
  render() {
    if (this.state.httpError) {
      return (
        <Layout tabActive="Fiscais de contrato">
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </Layout>
      )
    }
    return (
      <Layout tabActive="Fiscais de contrato">
        {this.state.showTable ? (
          <TableFiscaisTrash
            filter={this.filter}
            onRestore={this.didRestore}
            sizeClass=""
            title={"Fiscais de contrato deletados"}
            subtitle={"Listagem de todos os fiscais de contrato deletados"}
            backgroundColor="as-blue"
            rows={this.state.fiscais}
          />
        ) : (
          <Loading />
        )}
      </Layout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/fiscais/FiscaisTrash.js